import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Situacao from '../../../../components/auth/contratos/listar/form_situacao'


function SituacaoContratoScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Situação do Contrato" />
            <HeaderLogged />
            <Container>
               <Situacao />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default SituacaoContratoScreen;